import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const ImageCard = ({ image, alt }) => {
    const cardRef = useRef(null);
    const observerRef = useRef(null);
    const ctxRef = useRef(null);

    useEffect(() => {
        const el = cardRef.current;
        if (!el) return;

        ctxRef.current = gsap.context(() => {

            // ⭐ Ultra-smooth initial state
            gsap.set(el, {
                autoAlpha: 0,
                y: 80,
                filter: "blur(7px)"
            });

            const animateImageCard = () => {
                gsap.to(el, {
                    autoAlpha: 1,
                    y: 0,
                    filter: "blur(0px)",
                    duration: 0.5,
                    ease: "power4.out",
                    stagger: 0.4,
                });
            };

            if (typeof ScrollTrigger !== "undefined") {
                ScrollTrigger.create({
                    trigger: el,
                    start: "top 90%",
                    once: true,
                    onEnter: animateImageCard
                });

                setTimeout(() => ScrollTrigger.refresh(), 300);
            } else {
                const io = new IntersectionObserver((entries, obs) => {
                    if (entries[0].isIntersecting) {
                        animateImageCard();
                        obs.disconnect();
                    }
                });
                observerRef.current = io;
                io.observe(el);
            }

        }, cardRef);

        return () => {
            if (observerRef.current) observerRef.current.disconnect();
            if (ctxRef.current) ctxRef.current.revert();
        };
    }, []);

    return (
        <>
            {/* Prevent flash on first render */}
            <style>{`
                .image-card-anim {
                    opacity: 0;
                    transform: translateY(60px);
                    filter: blur(7px);
                }
            `}</style>

            <div
                ref={cardRef}
                className="image-card-anim overflow-hidden shadow-lg 
                           border border-white/10 rounded-md 
                           transition duration-300 cursor-pointer"
            >
                <img
                    src={image}
                    alt={alt}
                    className="w-full h-full object-cover"
                />
            </div>
        </>
    );
};

export default ImageCard;
